<template>
  <div :class="$options.name">
    <v-card v-if="mapType === 'point'" elevation="0">
      <v-card-title>Настройки отображения</v-card-title>

      <v-card-text>
        <v-select
          v-model="settingViewType"
          label="Тип отображения"
          :items="settingViewTypes"
          @change="onSettingViewTypeChange"
        />

        <template v-if="settingViewType === 'common'">
          <template v-if="settingsValue.hasDefaultPointSettings">
            <v-row>
              <v-col
                v-if="icon"
                md="1"
                class="common-icon-image-preview-col"
              >
                <img
                  alt=""
                  :src="icon.file.path"
                  :style="{ transform: iconTransformStyle }"
                >
              </v-col>
              <v-col
                v-else
                md="1"
                class="icon-common-img-col d-flex align-center justify-center"
              >
                <div
                  :style="{
                    outlineColor: settingsValue.defaultPointSettings.borderColor,
                    outlineWidth: settingsValue.defaultPointSettings.borderWidth + 'px',
                    backgroundColor: settingsValue.defaultPointSettings.color,
                    width: settingsValue.defaultPointSettings.size * 2 + 'px',
                    height: settingsValue.defaultPointSettings.size * 2 + 'px',
                  }"
                />
              </v-col>

              <v-col v-if="!icon" class="d-flex align-center">
                <v-menu
                  :close-on-content-click="false"
                  offset-x
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :color="settingsValue.defaultPointSettings.color"
                      :class="[`${getTextColor(settingsValue.defaultPointSettings.color)}--text`]"
                      class="mr-4"
                      small
                      dark
                      rounded
                      v-bind="attrs"
                      v-on="on"
                    >
                      Выбрать цвет точки
                    </v-btn>
                  </template>

                  <v-card>
                    <v-color-picker
                      v-model="settingsValue.defaultPointSettings.color"
                      mode="rgba"
                      flat
                    />
                  </v-card>
                </v-menu>
                <v-menu
                  :close-on-content-click="false"
                  offset-x
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :color="settingsValue.defaultPointSettings.borderColor"
                      :class="[
                        `${getTextColor(settingsValue.defaultPointSettings.borderColor)}--text`
                      ]"
                      class="mr-4"
                      small
                      rounded
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                      Выбрать цвет контура
                    </v-btn>
                  </template>

                  <v-card>
                    <v-color-picker
                      v-model="settingsValue.defaultPointSettings.borderColor"
                      mode="rgba"
                      flat
                    />
                  </v-card>
                </v-menu>
              </v-col>
            </v-row>

            <v-slider
              class="mt-5"
              step="1"
              min="1"
              max="20"
              thumb-label
              label="Размер иконки"
              :value="settingsValue.defaultPointSettings.size"
              @input="onIconRadiusChange($event, settingsValue.defaultPointSettings.size)"
            />

            <v-slider
              v-if="!icon"
              v-model="settingsValue.defaultPointSettings.borderWidth"
              class="mt-0"
              step="1"
              min="0"
              max="5"
              thumb-label
              label="Ширина контура"
            />
          </template>
        </template>

        <template v-if="settingViewType === 'custom'">
          <template v-if="!formFields.length">
            <v-icon key="back">info</v-icon>
            Для настройки данного раздела необходимо
            выбрать форму во вкладке "Основная информация"

            <br>
          </template>

          <v-card-text>
            <v-select
              v-if="settingsValue.hasIconView"
              v-model="settingsValue.iconView.type"
              label="Тип отображения"
              :items="iconViewTypes"
              :disabled="!formFields.length"
            />

            <template
              v-if="settingsValue.hasIconView && [
                'colors-icon',
                'colors-values-icon',
                'images-values-icon'
              ].includes(settingsValue.iconView.type)"
            >
              <v-select
                v-model="settingsValue.iconView.iconTextFrom"
                hide-details
                return-object
                item-value="id"
                item-text="name"
                item-disabled="disabled"
                :label="iconTextFromSelectLabel"
                :items="viewTypeFormFields"
                :disabled="!formFields.length"
              />

              <div v-if="settingsValue.iconView.iconTextFrom" class="mt-4">
                <v-slider
                  v-if="mapType === 'point'"
                  class="mt-6"
                  step="1"
                  min="1"
                  max="20"
                  thumb-label
                  label="Размер иконки"
                  :value="settingsValue.iconView.radius"
                  :disabled="!formFields.length"
                  @input="onIconRadiusChange($event, settingsValue.iconView.radius)"
                />

                <v-slider
                  v-if="['colors-icon', 'colors-values-icon'].includes(settingsValue.iconView.type)"
                  v-model="settingsValue.defaultPointSettings.borderWidth"
                  class="mt-0"
                  step="1"
                  min="0"
                  max="5"
                  thumb-label
                  label="Ширина контура"
                />

                <template v-if="settingsValue.iconView.type === 'images-values-icon'">
                  <h4>Иконки по значениям из поля:</h4>

                  <v-row
                    v-for="(item, index) in settingsValue.iconView.iconImageStops"
                    :key="index"
                    align="start"
                    class="mt-2"
                  >
                    <v-col md="1" class="custom-icon-image-preview-col">
                      <img
                        v-if="preparedImageStopsIcons[item.icon_id]"
                        alt=""
                        :src="preparedImageStopsIcons[item.icon_id].file.path"
                        :style="{ transform: iconTransformStyle }"
                      >
                    </v-col>
                    <v-col md="3">
                      <v-text-field
                        v-model="item.value"
                        label="Значение"
                        hide-details
                        :type="viewTypeIconStopInput"
                        :disabled="!formFields.length"
                      />
                    </v-col>

                    <v-col md="6">
                      <icon-select-component
                        v-model="item.icon_id"
                        label="Иконка элемента"
                        :data="preparedImageStopsIcons[item.icon_id]"
                        :list="icons"
                        :disabled="!formFields.length"
                        search
                        use-local-filter
                        search-label="Поиск иконок"
                      />
                    </v-col>

                    <v-col class="pt-8 pl-0">
                      <v-btn
                        color="error"
                        text
                        :disabled="!formFields.length"
                        @click="settingsValue.iconView.iconImageStops.splice(index, 1)"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-btn
                      color="primary"
                      class="mt-2"
                      small
                      text
                      :disabled="!formFields.length"
                      @click="onNewImageStopCreate"
                    >
                      Добавить иконку
                    </v-btn>
                  </v-row>
                </template>
                <template v-else>
                  <h4>Цвета иконки по значениям из поля:</h4>
                  <v-row
                    v-for="(item, index) in settingsValue.iconView.iconColorStops"
                    :key="index"
                    align="center"
                    class="mt-2"
                  >
                    <v-col md="1" class="d-flex justify-center align-center">
                      <div
                        class="icon-color-stops-img"
                        :style="{
                          backgroundColor: item.color,
                          width: settingsValue.iconView.radius * 2 + 'px',
                          height: settingsValue.iconView.radius * 2 + 'px',
                          outlineColor: item.borderColor,
                          outlineWidth: settingsValue.defaultPointSettings.borderWidth + 'px',
                        }"
                      />
                    </v-col>

                    <v-col md="6">
                      <v-text-field
                        v-model="item.value"
                        label="Значение"
                        hide-details
                        :type="settingsValue.iconView.type === 'colors-icon' ? 'number' : 'text'"
                        :disabled="!formFields.length"
                      />
                    </v-col>

                    <v-col md="3">
                      <v-menu
                        offset-x
                        :close-on-content-click="false"
                        :disabled="!formFields.length"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="mr-4"
                            small
                            dark
                            rounded
                            :color="item.color"
                            :class="[`${getTextColor(item.color)}--text`]"
                            :disabled="!formFields.length"
                            v-bind="attrs"
                            v-on="on"
                          >
                            Цвет точки
                          </v-btn>
                        </template>

                        <v-card>
                          <v-color-picker
                            v-model="item.color"
                            flat
                            :disabled="!formFields.length"
                          />
                        </v-card>
                      </v-menu>

                      <v-menu
                        offset-x
                        :close-on-content-click="false"
                        :disabled="!formFields.length"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="mr-4"
                            small
                            dark
                            rounded
                            :color="item.borderColor"
                            :class="[`${getTextColor(item.borderColor)}--text`]"
                            :disabled="!formFields.length"
                            v-bind="attrs"
                            v-on="on"
                          >
                            Цвет контура
                          </v-btn>
                        </template>

                        <v-card>
                          <v-color-picker
                            v-model="item.borderColor"
                            flat
                            :disabled="!formFields.length"
                          />
                        </v-card>
                      </v-menu>
                    </v-col>

                    <v-col md="1">
                      <v-btn
                        color="error"
                        text
                        :disabled="!formFields.length"
                        @click="settingsValue.iconView.iconColorStops.splice(index, 1)"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>

                  <v-btn
                    color="primary"
                    class="mt-2"
                    small
                    text
                    :disabled="!formFields.length"
                    @click="onNewStopCreate"
                  >
                    Добавить цвет
                  </v-btn>
                </template>
              </div>
            </template>
          </v-card-text>
        </template>
      </v-card-text>
    </v-card>

    <v-card v-if="mapType === 'polygon'" elevation="0">
      <v-card-title>Настройки отображения</v-card-title>

      <v-card-text>
        <v-select
          v-model="settingViewType"
          label="Тип отображения"
          :items="settingViewTypes"
          @change="onSettingViewTypeChange"
        />

        <template v-if="settingViewType === 'common'">
          <v-select
            :value="settingsValue.defaultAppearance"
            :items="[
              { value: 'default', text: 'Заливка цветом' },
              { value: 'outline', text: 'Контур' }
            ]"
            label="Визуализация по умолчанию"
            @change="onSettingValueDefaultAppearanceChange"
          />

          <template v-if="settingsValue.defaultAppearance === 'default'">
            <v-menu
              :close-on-content-click="false"
              offset-x
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="layerColor"
                  :class="[`${getTextColor(layerColor)}--text`]"
                  class="mr-4"
                  small
                  dark
                  rounded
                  v-bind="attrs"
                  v-on="on"
                >
                  Выбрать цвет
                </v-btn>
              </template>

              <v-card>
                <v-color-picker
                  v-model="layerColor"
                  flat
                />
              </v-card>
            </v-menu>
          </template>

          <template v-else-if="settingsValue.defaultAppearance === 'outline'">
            <v-slider
              v-model="settingsValue.width"
              label="Толщина линии"
              step="1"
              min="1"
              max="10"
              thumb-label
            />
            <v-menu
              :close-on-content-click="false"
              offset-x
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="lineColor"
                  :class="[`${getTextColor(lineColor)}--text`]"
                  class="mr-4"
                  small
                  dark
                  rounded
                  v-bind="attrs"
                  v-on="on"
                >
                  Выбрать цвет
                </v-btn>
              </template>

              <v-card>
                <v-color-picker
                  v-model="lineColor"
                  flat
                />
              </v-card>
            </v-menu>
          </template>
        </template>

        <v-card-text v-if="settingViewType === 'custom'">
          <template v-if="!formFields.length">
            <v-icon key="back">info</v-icon>
            Для настройки данного раздела необходимо выбрать форму во вкладке "Основная информация"

            <br>
          </template>

          <v-select
            v-if="settingsValue.hasIconView"
            v-model="settingsValue.iconView.type"
            label="Тип отображения"
            :items="iconViewTypes"
            :disabled="!formFields.length"
          />

          <v-select
            v-model="settingsValue.iconView.iconTextFrom"
            hide-details
            return-object
            item-value="id"
            item-text="name"
            item-disabled="disabled"
            :label="iconTextFromSelectLabel"
            :items="viewTypeFormFields"
            :disabled="!formFields.length"
          />

          <div v-if="settingsValue.iconView.iconTextFrom" class="mt-4">
            <h4>Цвет по значениям из поля:</h4>
            <v-row
              v-for="(item, index) in settingsValue.iconView.iconColorStops"
              :key="index"
              align="center"
              class="mt-2"
            >
              <v-col md="6">
                <v-text-field
                  v-model="item.value"
                  label="Значение"
                  hide-details
                  :type="viewTypeIconStopInput"
                  :disabled="!formFields.length"
                />
              </v-col>

              <v-col md="3">
                <v-menu
                  offset-x
                  :close-on-content-click="false"
                  :disabled="!formFields.length"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :color="item.color"
                      :class="[`${getTextColor(item.color)}--text`]"
                      class="mr-4"
                      small
                      dark
                      rounded
                      v-bind="attrs"
                      v-on="on"
                    >
                      Выбрать цвет
                    </v-btn>
                  </template>

                  <v-card>
                    <v-color-picker
                      v-model="item.color"
                      flat
                    />
                  </v-card>
                </v-menu>
              </v-col>

              <v-col md="1">
                <v-btn
                  color="error"
                  text
                  :disabled="!formFields.length"
                  @click="settingsValue.iconView.iconColorStops.splice(index, 1)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-btn
              color="primary"
              class="mt-2"
              small
              text
              :disabled="!formFields.length"
              @click="onNewStopCreate"
            >
              Добавить цвет
            </v-btn>
          </div>
        </v-card-text>
      </v-card-text>
    </v-card>

    <v-card v-if="mapType === 'linestring'" elevation="0">
      <v-card-title>Цвет и прозрачность слоя</v-card-title>
      <v-card-text>
        <v-menu
          :close-on-content-click="false"
          offset-x
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :color="layerColor"
              :class="[`${getTextColor(layerColor)}--text`]"
              class="mr-4"
              small
              dark
              rounded
              v-bind="attrs"
              v-on="on"
            >
              Выбрать цвет
            </v-btn>
          </template>

          <v-card>
            <v-color-picker
              v-model="layerColor"
              flat
            />
          </v-card>
        </v-menu>
        <v-slider
          v-if="['linestring'].includes(mapType)"
          v-model="settingsValue['line-width']"
          prepend-icon="line_weight"
          label="Толщина"
          thumb-label
          max="10"
          min="1"
        />
      </v-card-text>
    </v-card>

    <v-card v-if="mapType === 'linestring'" elevation="0">
      <v-card-title>
        Настройки отображения объекта
      </v-card-title>
      <v-card-subtitle>
        Можно выбрать поле из формы слоя из которого будет
        выводиться текст/значение на картографический объект.
        Так же можно установить определенные цвета объекта для каждого значение из поля
      </v-card-subtitle>

      <v-card-text>
        <v-checkbox
          v-model="settingsValue.hasIconView"
          label="Динамический вид объекта"
          dense
        />

        <v-select
          v-if="settingsValue.hasIconView"
          v-model="settingsValue.iconView.type"
          label="Тип отображения"
          :items="iconViewTypes"
        />

        <template
          v-if="settingsValue.hasIconView
            && ['colors-values-icon','colors-icon'].includes(settingsValue.iconView.type)"
        >
          <v-select
            v-model="settingsValue.iconView.iconTextFrom"
            hide-details
            return-object
            item-value="id"
            item-text="name"
            item-disabled="disabled"
            no-data-text="Нет доступных полей. Проверьте форму"
            :label="iconTextFromSelectLabel"
            :items="viewTypeFormFields"
          />

          <div v-if="settingsValue.iconView.iconTextFrom" class="mt-4">
            <h4>Цвет по значениям из поля:</h4>
            <v-row
              v-for="(item, index) in settingsValue.iconView.iconColorStops"
              :key="index"
              align="center"
              class="mt-2"
            >
              <v-col md="6">
                <v-text-field
                  v-model="item.value"
                  label="Значение"
                  hide-details
                  :type="viewTypeIconStopInput"
                />
              </v-col>

              <v-col md="3">
                <v-menu
                  :close-on-content-click="false"
                  offset-x
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :color="item.color"
                      :class="[`${getTextColor(item.color)}--text`]"
                      class="mr-4"
                      small
                      dark
                      rounded
                      v-bind="attrs"
                      v-on="on"
                    >
                      Выбрать цвет
                    </v-btn>
                  </template>

                  <v-card>
                    <v-color-picker
                      v-model="item.color"
                      flat
                    />
                  </v-card>
                </v-menu>
              </v-col>

              <v-col md="1">
                <v-btn
                  color="error"
                  text
                  @click="settingsValue.iconView.iconColorStops.splice(index, 1)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-btn
              color="primary"
              class="mt-2"
              small
              text
              @click="onNewStopCreate"
            >
              Добавить цвет
            </v-btn>
          </div>
        </template>
      </v-card-text>
    </v-card>

    <v-card elevation="0">
      <v-card-title>Привязка к таймлайну</v-card-title>
      <v-card-subtitle>Можно выбрать доступный тип таймлайна для объекта.</v-card-subtitle>

      <v-card-text>
        <v-select
          v-model="settingsValue.timelineType"
          :items="timelineTypes"
          label="Тип таймлайна для объекта"
        />
      </v-card-text>
    </v-card>

    <v-card elevation="0">
      <v-card-title>Режим реального времени</v-card-title>
      <v-card-text>
        <v-checkbox
          v-model="settingsValue.isLiveData"
          label="Отправлять данные в режиме реального времени до клиента"
          dense
        />
      </v-card-text>
    </v-card>

    <v-card elevation="0">
      <v-card-title>Поведение при включении</v-card-title>
      <v-card-text>
        <v-checkbox
          v-model="settingsValue.autofocus"
          label="Автоматически переносить камеру в описывающую область геометрий"
          dense
        />
      </v-card-text>
    </v-card>

    <v-card elevation="0">
      <v-card-title>Зависимость слоя от масштаба</v-card-title>
      <v-card-subtitle>
        Укажите границы масштаба при котором слой будет отображаться
      </v-card-subtitle>
      <v-card-text>
        <v-checkbox
          v-model="settingsValue.hasZoomDependence"
          label="Включить зависимость слоя от масштаба"
          dense
        />

        <template v-if="settingsValue.hasZoomDependence">
          <v-range-slider
            v-model="settingsValue.zoomDependence"
            step="1"
            min="1"
            max="22"
            thumb-label
          />
        </template>
      </v-card-text>
    </v-card>
    <!-- Это было v-if="['point', 'linestring', 'polygon'] - тут другого типа бытьне может -->
    <v-card elevation="0">
      <v-card-title>
        Трансформация при отдалении/приближении карты
      </v-card-title>
      <v-card-subtitle>
        Функция позволяет скрывать сам объект и вместо него отображать текст из карточки объекта,
        взависимости от масштаба карты
      </v-card-subtitle>
      <v-card-text>
        <v-checkbox
          v-model="settingsValue.hasCameraTransformation"
          label="Включить трансформацию"
          dense
        />

        <template v-if="settingsValue.hasCameraTransformation">
          <v-select
            v-model="settingsValue.cameraTransformation.formField"
            hide-details
            return-object
            item-text="name"
            item-value="id"
            label="Поле, значение которого будет выводиться вместо объекта"
            no-data-text="Нет доступных полей. Проверьте форму"
            :items="formFields"
          />

          <v-slider
            v-model="settingsValue.cameraTransformation.minZoom"
            label="Минимальное значение отдаления камеры для трансформации"
            step="1"
            min="1"
            max="22"
            class="mt-4"
            thumb-label
          />

          <v-checkbox
            v-model="settingsValue.cameraTransformation.alwaysShowed"
            label="Оставлять объект на карте"
            class="mt-1 mb-4"
            hide-details
          />

          <v-menu
            class="d-block"
            :close-on-content-click="false"
            offset-x
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :color="settingsValue.cameraTransformation.textColor"
                :class="[`${getTextColor(settingsValue.cameraTransformation.textColor)}--text`]"
                class="mt-2"
                small
                rounded
                dark
                v-bind="attrs"
                v-on="on"
              >
                Выбрать цвет текста
              </v-btn>
            </template>

            <v-card>
              <v-color-picker
                v-model="settingsValue.cameraTransformation.textColor"
                mode="rgba"
                flat
              />
            </v-card>
          </v-menu>
          <v-slider
            v-model="settingsValue.cameraTransformation.textSize"
            class="mt-2"
            label="Размер текста"
            min="1"
            max="16"
            step="1"
            thumb-label
          />
        </template>
      </v-card-text>
    </v-card>

    <v-card v-if="mapType === 'point'" elevation="0">
      <v-card-title>Стиль отображения: Тепловая карта</v-card-title>

      <v-card-text>
        <v-select
          v-model="settingsValue.viewStyleSettings.heatmap.weightValueFrom"
          return-object
          hide-details
          item-text="name"
          item-value="id"
          label="Поле, которое будет обозначать 'Вес' точки на тепловой карте по-умолчанию"
          no-data-text="Полей с типом 'Числовое' не найдено. Проверьте форму"
          clearable
          :items="intFormFields"
        />

        <v-slider
          v-model="settingsValue.viewStyleSettings.heatmap.heatmapIntensity"
          label="Интенсивность элемента тепловой карты"
          class="mt-6"
          min="0.1"
          max="2"
          step="0.1"
        />

        <v-slider
          v-model="settingsValue.viewStyleSettings.heatmap.heatmapThreshold"
          label="Порог свечения элемента"
          min="0.01"
          max="1"
          step="0.01"
        />

        <v-slider
          v-model="settingsValue.viewStyleSettings.heatmap.heatmapRadiusPixel"
          label="Радиус элемента тепловой карты"
          min="5"
          max="800"
          step="1"
        />

        <v-checkbox
          v-model="settingsValue.viewStyleSettings.heatmap.hasCustomColors"
          label="Изменить палитру цветов тепловой карты"
          dense
        />

        <template v-if="settingsValue.viewStyleSettings.heatmap.hasCustomColors">
          <small>Необходимо установить 6 цветов, от меньшего к большему</small>

          <v-menu
            v-for="i in [0, 1, 2, 3, 4, 5]"
            :key="`${i}-heatmap-colors`"
            class="d-block mt-2"
            :close-on-content-click="false"
            offset-x
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :color="heatmapColor(i)"
                :class="[
                  `${getTextColor(heatmapColor(i))}--text`
                ]"
                class="mr-4"
                small
                dark
                rounded
                v-bind="attrs"
                v-on="on"
              >
                Выбрать цвет
              </v-btn>
            </template>

            <v-card>
              <v-color-picker
                v-model="settingsValue.viewStyleSettings.heatmap.colors[i].value"
                flat
              />
            </v-card>
          </v-menu>
        </template>
      </v-card-text>
    </v-card>

    <v-card v-if="mapType === 'point'" elevation="0">
      <v-card-title>Диаграмма Вороного</v-card-title>
      <v-card-text>
        <v-checkbox
          v-model="settingsValue.viewStyleSettings.voronoi.isEnabled"
          label="Отображать в виде диаграммы Вороного (Тестовый режим)"
          dense
        />

        <template v-if="settingsValue.viewStyleSettings.voronoi.isEnabled">
          <object-view-settings-voronoi
            v-for="(level, i) in settingsValue.viewStyleSettings.voronoi.levels"
            :key="`${i}-voronoi-colors`"
            :level="level"
          />
        </template>
      </v-card-text>
    </v-card>

    <v-card v-if="mapType === 'point'" elevation="0">
      <v-card-title>Кластеризация</v-card-title>
      <v-card-text>
        <v-checkbox
          v-model="settingsValue.disabledClusters"
          label="Отключить кластеризацию"
          dense
        />
      </v-card-text>
    </v-card>

    <v-card elevation="0">
      <v-card-title>Исторические изменения</v-card-title>
      <v-card-subtitle>
        В карточке объекта выводится график, который по набору выбранных условий
        отображает линейные изменения значений объекта по отношению к выбранному полю
        (или дате события).
      </v-card-subtitle>

      <v-card-text>
        <v-checkbox
          v-model="settingsValue.hasFunction"
          label="Отображать график"
          dense
        />

        <v-checkbox
          v-if="settingsValue.hasFunction"
          v-model="settingsValue.advancedGraphDesign"
          label="Расширенный вид графика"
          dense
        />

        <template v-if="settingsValue.hasFunction">
          <v-select
            v-model="settingsValue.functionHeader"
            hide-details
            item-text="name"
            item-value="id"
            label="Поле, по которому будет производится выборка объектов для сравнения"
            no-data-text="Нет доступных полей. Проверьте форму"
            :items="formFields"
          />
          <v-checkbox
            v-model="settingsValue.functionXAxisIsDate"
            label="Использовать дату события как ось X"
            dense
          />
          <v-select
            v-if="!settingsValue.functionXAxisIsDate"
            v-model="settingsValue.functionXAxis"
            hide-details
            item-text="name"
            item-value="id"
            label="Поле, принимаемое за ось X"
            no-data-text="Нет доступных полей. Проверьте форму"
            :items="formFields"
          />
          <v-select
            v-model="settingsValue.functionYAxis"
            hide-details
            item-text="name"
            item-value="id"
            no-data-text="Нет доступных полей. Проверьте форму"
            label="Поле, принимаемое за ось Y"
            :items="formFields"
          />
        </template>
      </v-card-text>
    </v-card>

    <div class="mt-2 d-flex pa-5">
      <div class="d-flex flex-grow-1" />
      <v-btn
        color="primary"
        :disabled="settingViewType === 'custom' && !formFields.length"
        @click="onSave"
      >
        Сохранить
      </v-btn>
    </div>
  </div>
</template>

<style scoped>
  .common-icon-image-preview-col {
    max-height: 25px;
    padding-left: 30px;
  }

  .custom-icon-image-preview-col {
    position: relative;
  }

  .custom-icon-image-preview-col > img {
    position: absolute;
    left: 50px;
    top: 40px;
  }

  .icon-color-stops-img {
    border-radius: 100%;
    outline-style: solid;
  }

  .icon-common-img-col {
    min-height: 65px;
  }

  .icon-common-img-col > div {
    border-radius: 100%;
    outline-style: solid;
    margin-left: 20px;
  }
</style>

<script>
import GetTextColor from '@/utils/get-text-color';
import IconSelectComponent from '@/components/ui/icon-select';
import { freezeObject } from '@/utils/object';
import { merge } from 'lodash';
import ObjectViewSettingsVoronoi from './ObjectViewSettingsVoronoi.vue';

const createIconColorStop = () => ({
  color: '#000000',
  borderColor: '#EEEEEE',
  value: null,
});

const createIconImageStop = () => ({
  icon_id: null,
  value: null,
});

const createDefaultSettings = () => ({
  color: '#0084FF',
  opacity: 0.56,
  showModal: false,
  hasFunction: false,
  functionHeader: null,
  functionXAxisIsDate: true,
  functionXAxis: null,
  functionYAxis: null,
  hasIconView: false,
  advancedGraphDesign: false,
  mapboxIconScale: 0.075,
  iconView: {
    iconTextFrom: null,
    iconColorStops: [],
    iconImageStops: [],
    type: 'colors-icon',
    radius: 10,
  },
  hasCameraTransformation: false,
  cameraTransformation: {
    formField: null,
    minZoom: 1,
    alwaysShowed: false,
    textColor: '#FFF',
    textSize: 16,
  },
  isLiveData: false,
  disabledClusters: false,
  autofocus: false,
  timelineType: null,
  viewStyleSettings: {
    heatmap: {
      weightValueFrom: null,
      heatmapIntensity: 1,
      heatmapThreshold: 0.02,
      heatmapRadiusPixel: 60,
      hasCustomColors: false,
      colors: [
        { id: 1, value: '#3BEB2F' },
        { id: 2, value: '#7DFF00' },
        { id: 3, value: '#D3FF00' },
        { id: 4, value: '#FFE400' },
        { id: 5, value: '#FF9500' },
        { id: 6, value: '#FF0000' },
      ],
    },
    voronoi: {
      isEnabled: false,
      levels: [
        { id: 1, color: '#0CB800', threshold: 0 },
        { id: 2, color: '#99FF00', threshold: 1 },
        { id: 3, color: '#E7FF00', threshold: 2 },
        { id: 4, color: '#FFD600', threshold: 3 },
        { id: 5, color: '#FF9500', threshold: 4 },
        { id: 6, color: '#FF0000', threshold: 5 },
      ],
    },
  },
  hasZoomDependence: false,
  zoomDependence: [1, 22],
  hasDefaultPointSettings: false,
  defaultPointSettings: {
    size: 10,
    color: '#000',
    borderColor: '#fff',
    borderWidth: 1,
  },
  hasBorderSettings: false,
  width: 2,
  lineColor: '#000',
  lineOpacity: 1.0,
  defaultAppearance: 'default',
});

export default {
  name: 'object-view-settings-form',
  components: {
    ObjectViewSettingsVoronoi,
    IconSelectComponent,
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    mapType: String,
    form: {
      type: Object,
      default: null,
    },
    value: {
      type: [Object, null],
      default: createDefaultSettings,
    },
    icons: {
      type: Array,
      default: () => [],
    },
    icon: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    settingViewType: null,
    settingsValue: null,
    timelineTypes: [
      { text: 'Без привязки', value: null },
      { text: 'Период', value: 'period' },
      { text: 'Дата', value: 'date' },
      { text: 'Период и дата', value: 'all' },
    ],
    settingViewTypes: [
      { value: 'common', text: 'Общий' },
      { value: 'custom', text: 'Динамический (в зависимости от значений выбранного поля)' },
    ],
  }),
  computed: {
    formFields() {
      return this.form?.fields ?? [];
    },

    viewTypeFormFields() {
      const isColorsIcon = this.settingsValue.iconView.type === 'colors-icon';
      return this.formFields.map((i) => ({
        ...i,
        disabled: isColorsIcon && !['int', 'double'].includes(i.type),
      }));
    },

    iconTextFromSelectLabel() {
      const baseLabel = 'Поле, значение которого будет использоваться';
      if (this.settingsValue.iconView.type === 'colors-icon') {
        return `${baseLabel} (для типа отображения "Интерполяция" доступны поля только с типом "Вещественный" и "Целочисленный")`;
      }
      return baseLabel;
    },

    viewTypeIconStopInput() {
      return this.settingsValue.iconView.type === 'colors-icon' ? 'number' : 'text';
    },

    iconTransformStyle() {
      const scale = this.settingsValue.mapboxIconScale ?? 1;
      return `translate(-50%, -50%) scale(${scale})`;
    },

    getTextColor() {
      return (i) => {
        if (!i) return 'white';
        return GetTextColor(i);
      };
    },

    iconImageStopsIds() {
      return this.settingsValue.iconView.iconImageStops?.map(
        i => i.icon_id,
      ) || null;
    },

    preparedImageStopsIcons() {
      if (!this.iconImageStopsIds) return null;

      return this.icons
        .filter(icon => this.iconImageStopsIds.includes(icon.id))
        .reduce((obj, item) => Object.assign(obj, { [item.id]: item }), {});
    },

    iconViewTypes() {
      const types = [
        { value: 'colors-icon', text: 'Интерполяция цвета' },
        { value: 'colors-values-icon', text: 'Цвет по значениям' },
      ];

      if (this.mapType === 'point') {
        types.push({ value: 'images-values-icon', text: 'Иконка (По значениям)' });
      }

      return types;
    },

    layerColor: {
      get() {
        const alpha = this.getHexAlpha(this.settingsValue.opacity);
        return this.settingsValue.color.concat(alpha);
      },

      set(value) {
        if (value !== this.layerColor) {
          this.updateColorAndOpacity(value, 'color', 'opacity');
        }
      },
    },

    lineColor: {
      get() {
        const alpha = this.getHexAlpha(this.settingsValue.lineOpacity);
        return this.settingsValue.lineColor.concat(alpha);
      },

      set(value) {
        if (value !== this.lineColor) {
          this.updateColorAndOpacity(value, 'lineColor', 'lineOpacity');
        }
      },
    },

    intFormFields() {
      return this.formFields.filter(_ => _.type === 'int');
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.settingsValue = merge(createDefaultSettings(), freezeObject(value));

        if (this.mapType === 'point') {
          if (this.settingsValue.hasDefaultPointSettings) this.settingViewType = 'common';
          if (this.settingsValue.hasIconView) this.settingViewType = 'custom';
        }

        if (this.mapType === 'polygon') {
          this.settingViewType = this.settingsValue.defaultAppearance ? 'common' : 'custom';
        }
      },
    },
  },
  mounted() {
    this.onSettingViewTypeChange(this.settingViewType);
    this.valuesWithoutChange = Object.assign({}, this.settingsValue);
    this.$emit('registerGuard', [this.valuesWithoutChange, this.beforeLeave]);
  },
  created() {
    // eslint-disable-next-line max-len
    this.settingsValue.viewStyleSettings.heatmap.colors = this.settingsValue.viewStyleSettings.heatmap.colors.map(
      (color) => {
        if (!color.value) {
          return { ...color, value: '#000' };
        }

        if (typeof color.value === 'object') {
          return { ...color, value: color.value.hex };
        }

        return color;
      },
    );
  },
  methods: {
    beforeLeave() {
      return this.settingsValue;
    },
    deleteLink(index) {
      this.settingsValue.source.links.splice(index, 1);
    },
    getHexAlpha(opacity) {
      return Math.round(opacity * 255).toString(16).toUpperCase();
    },

    updateColorAndOpacity(rgba, colorField, opacityField) {
      const alpha = parseInt(rgba.substr(-2), 16);
      const opacity = 1 - parseFloat(((255 - alpha) / 255.0).toFixed(1));
      const color = rgba.substr(0, rgba.length - 2);

      this.$set(this.settingsValue, colorField, color);
      this.$set(this.settingsValue, opacityField, opacity);
    },
    onSettingValueDefaultAppearanceChange(value) {
      this.settingsValue.defaultAppearance = value;

      this.settingsValue.hasBorderSettings = value === 'outline';
    },

    onIconRadiusChange(value, old) {
      const { mapboxIconScale } = this.settingsValue;

      this.settingsValue.iconView.radius = value;
      this.settingsValue.defaultPointSettings.size = value;
      this.settingsValue.mapboxIconScale = mapboxIconScale / old * value;
    },

    onSettingViewTypeChange(value) {
      if (this.mapType === 'point') {
        const { iconImageStops } = this.settingsValue.iconView;

        if (value === 'common') {
          this.settingsValue.hasDefaultPointSettings = true;
          this.settingsValue.hasIconView = false;

          if (this.icon) {
            this.setMapboxIconScale(
              this.icon.file.path,
              this.settingsValue.defaultPointSettings.size,
            );
          }
        }

        if (value === 'custom') {
          this.settingsValue.hasDefaultPointSettings = false;
          this.settingsValue.hasIconView = true;

          // eslint-disable-next-line camelcase
          if (iconImageStops?.length && iconImageStops[0]?.icon_id) {
            const filePath = this.preparedImageStopsIcons[iconImageStops[0].icon_id].file.path;
            const { radius } = this.settingsValue.iconView;

            this.setMapboxIconScale(filePath, radius);
          }
        }
      }

      if (this.mapType === 'polygon') {
        if (value === 'common') {
          this.settingsValue.defaultAppearance = this.settingsValue.defaultAppearance || 'default';
          this.settingsValue.hasIconView = false;
        }

        if (value === 'custom') {
          this.settingsValue.defaultAppearance = null;
          this.settingsValue.hasIconView = true;
          this.settingsValue.iconView.type = 'colors-values-icon';
        }
      }

      const { iconColorStops } = this.settingsValue.iconView;

      if (iconColorStops?.length && iconColorStops[0]?.color) {
        this.settingsValue.iconView.iconColorStops = iconColorStops.map((i) => ({
          ...i,
          borderColor: i.borderColor ?? '#EEEEEE',
        }));
      }
    },

    setMapboxIconScale(src, radius) {
      const iconImage = new Image();

      iconImage.onload = (e) => {
        this.settingsValue.mapboxIconScale = radius * 2 / e.target.width;
      };

      iconImage.src = src;
    },

    onSave() {
      if (this.settingsValue.hasDefaultPointSettings) {
        const { color, borderColor } = this.settingsValue.defaultPointSettings;
        if (color.length > 7) {
          this.settingsValue.defaultPointSettings.color = color.substr(0, color.length - 2);
        }
        if (borderColor.length > 7) {
          // eslint-disable-next-line max-len
          this.settingsValue.defaultPointSettings.borderColor = borderColor.substr(0, borderColor.length - 2);
        }
      }

      if (this.settingsValue.lineColor) {
        if (this.settingsValue.lineColor.length > 7) {
          this.settingsValue.lineColor = this.settingsValue.lineColor.substr(0, 7);
        }
      }

      if (this.settingsValue.hasCameraTransformation) {
        const { textColor } = this.settingsValue.cameraTransformation;
        if (textColor.length > 7) {
          // eslint-disable-next-line max-len
          this.settingsValue.cameraTransformation.textColor = textColor.substr(0, textColor.length - 2);
        }
      }

      const iconTextFromId = this.settingsValue?.iconView?.iconTextFrom?.id;
      if (iconTextFromId) {
        const iconViewFormField = this.viewTypeFormFields.find(({ id }) => (id === iconTextFromId));

        if (iconViewFormField) {
          this.settingsValue.iconView.iconTextFrom = { ...iconViewFormField };
        }
      }

      this.valuesWithoutChange = Object.assign({}, this.settingsValue);

      this.$emit('registerGuard', [this.valuesWithoutChange, this.beforeLeave]);
      this.$emit('save', this.settingsValue);
    },

    onNewStopCreate() {
      this.settingsValue.iconView.iconColorStops.push(createIconColorStop());
    },

    onNewImageStopCreate() {
      this.settingsValue.iconView.iconImageStops.push(createIconImageStop());
    },

    heatmapColor(i) {
      return this.settingsValue.viewStyleSettings.heatmap.colors[i].value;
    },
  },
};
</script>
